module.exports = "mat-table {\n    position: relative;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/kiosk-list/kiosk-list.component.css
// module id = ./src/app/kiosk-list/kiosk-list.component.css
// module chunks = main